// Copyright © 2021 Move Closer
import { SizeMap } from '../../_composables';
import { BootstrapTheme } from '../common';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapButtonSizeRegistry = {
    [SizeMap.Small]: 'btn-sm',
    [SizeMap.Medium]: '',
    [SizeMap.Large]: 'btn-lg'
};
export const bootstrapButtonThemeRegistry = {
    [BootstrapTheme.Default]: '',
    [BootstrapTheme.Danger]: 'btn-danger',
    [BootstrapTheme.Dark]: 'btn-dark',
    [BootstrapTheme.Info]: 'btn-info',
    [BootstrapTheme.Light]: 'btn-light',
    [BootstrapTheme.Primary]: 'btn-primary',
    [BootstrapTheme.Secondary]: 'btn-secondary',
    [BootstrapTheme.Success]: 'btn-success',
    [BootstrapTheme.Warning]: 'btn-warning'
};
